import React, { useState } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import PrintIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { deleteHPDAffidavit } from '../../../../../sevices/violationsApi';
import AffidavitIcon from '../../../../../styles/svg/affidavit-document.svg';
import DeleteIcon from "../../../../../styles/svg/delete.svg";
import ConfirmationDialog from '../../../../../components/Dialog/ConfirmationDialog';
import { isAdmin } from '../../../../../utils/helpers';

function AffidavitListItem({ item, onDelete, onPrint }) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  // Mock delete mutation - replace with actual API call
  const { mutate: deleteAffidavit, isPending } = useMutation({
    mutationFn: (id) => deleteHPDAffidavit(id),
    onSuccess: () => {
      toast.success('Affidavit deleted successfully');
      if (onDelete) onDelete(item.affidavit_id);
      setShowConfirmation(false);
    },
    onError: () => {
      toast.error('Failed to delete affidavit');
      setIsDeleting(false);
      setShowConfirmation(false);
    }
  });

  const handlePrint = () => {
    try {
      // Get the base URL from environment or fallback to the API base URL
      const baseUrl = process.env.REACT_APP_BASE_URL || '';
      
      // Create the URL for the affidavit file
      const fileUrl = `${baseUrl}/affidavit/${item.file_path}`;
      
      // Open the file in a new window
      const printWindow = window.open(fileUrl, '_blank');
      
      if (printWindow) {
        // Wait for the window to load and then print
        printWindow.addEventListener('load', () => {
          try {
            printWindow.focus();
            printWindow.print();
          } catch (error) {
            console.error('Print error:', error);
            toast.error('Failed to print document');
          }
        });
      } else {
        // If popup blocker prevented opening the window
        toast.error('Please allow popups to print the document');
      }
    } catch (error) {
      console.error('Print error:', error);
      toast.error('Failed to print document');
    }
  };

  const handleDelete = () => {
    setShowConfirmation(true);
  };

  const confirmDelete = () => {
    deleteAffidavit(item.affidavit_id);
  };

  const cancelDelete = () => {
    setShowConfirmation(false);
  };

  return (
    <>
      <Box className="affidavit-item">
        <Box className="affidavit-item-left">
          <img src={AffidavitIcon} alt="affidavit" className="pdf-icon" />
          <Box>
            <Typography className="affidavit-item-title">
              {item.affidavit_name}
            </Typography>
          </Box>
        </Box>

        <Box
          className="affidavit-item-actions"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Button
            variant="contained"
            startIcon={<PrintIcon style={{ width: "15px", height: "15px" }} />}
            onClick={handlePrint}
            className="print-button"
          >
            Print
          </Button>

          {isAdmin() && (
            <IconButton onClick={handleDelete} disabled={isPending}>
              <img src={DeleteIcon} alt="delete" />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={showConfirmation}
        handleClose={cancelDelete}
        message={`Are you sure you want to delete this affidavit: "${item.affidavit_name}"? This action cannot be undone.`}
        callback={confirmDelete}
        loading={isPending}
        btnTitle={"Delete"}
        title={"Confirm Deletion"}
        btnColor="#B71D18" // Error red color
      />
    </>
  );
}

export default AffidavitListItem;